import { render, staticRenderFns } from "./ExibeTipoQuestoes.vue?vue&type=template&id=32019c35&scoped=true"
import script from "./ExibeTipoQuestoes.vue?vue&type=script&lang=js"
export * from "./ExibeTipoQuestoes.vue?vue&type=script&lang=js"
import style0 from "./ExibeTipoQuestoes.vue?vue&type=style&index=0&id=32019c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32019c35",
  null
  
)

export default component.exports